import { memo } from "react";
import { InputProps } from "@material-ui/core";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      padding: theme.spacing(3),
      paddingTop: theme.spacing(1),
      borderRadius: "4px",
      background: "#E5E5E5",
      width: "100%",
      marginBottom: "16px",
    },
    table: {
      padding: theme.spacing(3),
      borderRadius: "4px",
      background: "#f8f8f8",
      width: "100%",
    },
    // margin: {
    //   margin: theme.spacing(1),
    // },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    // textField: {
    //   maxWidth: 'calc(100% - 12px)',
    // },
    input: {
      "& .MuiInputBase-input": {
        boxShadow: "none",
        fontSize: "1.2rem",
        fontWeight: "500",
        textTransform: "uppercase",
      },
    },
  })
);

interface SearchInputProps extends InputProps {}

const SearchInput = (props: SearchInputProps) => {
  const classes = useStyles();

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="standard-adornment-password">
        FILTRAR PESQUISA
      </InputLabel>
      <Input
        fullWidth
        id="search"
        type="text"
        placeholder={props.placeholder}
        className={classes.input}
        value={props.value}
        onChange={props.onChange}
        endAdornment={
          <InputAdornment position="end">
            {/* <IconButton
              aria-label="toggle password visibility"
              onClick={() => alert('teste')}
            > */}
            <SearchIcon fontSize="large" />
            {/* </IconButton> */}
          </InputAdornment>
        }
        inputProps={{
          autoComplete: "off",
          form: {
            autoComplete: "off",
          },
        }}
      />
    </FormControl>
  );
};

export default memo(SearchInput);
